const header = {
  homepage: 'https://matejicmilan.com/',
  title: 'MM.',
}

const about = {
  name: 'Milan Matejic',
  role: 'Web & Mobile Developer',
  resume:
    'https://drive.google.com/file/d/17zm4YvJF5-Xf4gV8x1LeE2le1YDTVcl8/view?usp=sharing',
  social: {
    linkedin: 'https://www.linkedin.com/in/matejic83/',
    github: 'https://github.com/Mateja3m',
  },
}

const projects = [
  {
    name: 'Dreamy - Discover Your Dreams',
    description:
      'A mobile application for recording and interpreting dreams, available in Serbian/English.',
    stack: ['Expo & React Native, ChatGPT 4o-mini API, CSS'],
    livePreview:
      'https://play.google.com/store/apps/details?id=com.anonymous.tumacsnova',
    previewImage: '/images/dreamy-preview.png',
  },
  {
    name: 'Maja-Maki-Taxi',
    description:
      'First commercial project created for the local taxi company. Website is not in English. ',
    stack: ['JavaScript, CSS, Bootstrap'],
    livePreview: 'https://maja-maki.com/',
    previewImage: '/images/maja-maki-preview.png',
  },
  {
    name: 'JavaScript Calculator',
    description:
      'This app is part of the curriculum of the FreeCodeCamp front end certification',
    stack: ['CSS', 'JavaScript', 'Responsive', 'Grid'],
    sourceCode: 'https://github.com/Mateja3m/js-calculator',
    livePreview: 'https://fcc-calc-app.netlify.app/',
    previewImage: '/images/calculator-preview.png',
  },
  {
    name: 'Drum Machine',
    description:
      "App build as part of the freeCodeCamp's curriculum using React.js, Bootstrap and grid layout",
    stack: ['React', 'Bootstrap', 'Grid'],
    sourceCode: 'https://github.com/Mateja3m/fcc-drum-machine',
    livePreview: 'https://fcc-drum-machine-app.netlify.app/',
    previewImage: '/images/drum-machine-preview.png',
  },
  {
    name: 'Address Book App',
    description:
      'App build using React.js, with functional components, useState hook, forms',
    stack: ['React'],
    sourceCode: 'https://github.com/Mateja3m/react-address-book',
    livePreview: 'https://address-colection-app.netlify.app/',
    previewImage: '/images/address-book-preview.png',
  },
  {
    name: 'Markdown Previewer',
    description:
      'Markdown Previewer is created using React.js, with help of Bootstrap and CSS',
    stack: ['CSS', 'React', 'Bootstrap'],
    sourceCode: 'https://github.com/Mateja3m/fcc-markdown-previewer',
    livePreview: 'https://app-markdown-preview.netlify.app/',
    previewImage: '/images/markdown-previewer.png',
  },
]

const skills = [
  'HTML',
  'CSS',
  'JavaScript',
  'React',
  'Next.js',
  'React Native',
  'Strapi CMS',
  "HubSpot's CMS",
  'SASS',
  'Bootstrap',
  'Storybook',
  'MUI',
  'Git',
  'Postman',
]

export { header, about, projects, skills }
